import formatRelative from 'date-fns/formatRelative';
import { formatTranslation } from 'intl';
import { AnalyticsTranslationKeys, CommonTranslationKeys } from 'intl/keys';
import { calendarLocales } from 'intl/calendarLocales';
import type { IntlShape } from 'react-intl';

export function toRelativeDate(
  date: Date | undefined,
  baseDate: Date,
  fallback: string,
  locale: string
): string {
  return date
    ? formatRelative(date, baseDate, { locale: calendarLocales[locale] })
    : fallback;
}

export function capitalize(text: string): string {
  return text[0].toLocaleUpperCase() + text.slice(1);
}

export function formatChartLastUpdate(
  intl: IntlShape,
  updatedAt: number | undefined
): string {
  return `${formatTranslation(intl, AnalyticsTranslationKeys.lastUpdate)}: ${capitalize(
    toRelativeDate(
      updatedAt ? new Date(updatedAt) : undefined,
      new Date(),
      formatTranslation(intl, CommonTranslationKeys.never),
      intl.locale
    )
  )}`;
}
